import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Box, styled } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var BannerLogo = styled('img')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-height: 100%;\n  max-width: 100%;\n"])));

var BannerBlock = function BannerBlock(_ref) {
  var imageUrl = _ref.block.imageUrl;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: {
        xs: 'none',
        md: 'block'
      },
      width: 1,
      backgroundColor: function backgroundColor(t) {
        return t.palette.other.banner;
      },
      height: 100
    },
    "data-element": "Box",
    "data-component": "BannerBlock",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        maxWidth: 1180,
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        margin: 'auto',
        overflow: 'hidden'
      },
      "data-element": "Box",
      "data-component": "BannerBlock",
      "data-source-file": "index.tsx",
      children: imageUrl ? /*#__PURE__*/_jsx(BannerLogo, {
        src: imageUrl,
        alt: "Company Logo"
      }) : null
    })
  });
};

export default BannerBlock;